var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countdown"},[(_vm.checkouttime > 0)?_c('span',[_vm._v(_vm._s(_vm.minutes)+":"+_vm._s(_vm.seconds))]):_vm._e(),_vm._v(" "),(_vm.checkouttime <= 0)?_c('span',[_vm._v(_vm._s(_vm.trans('passed')))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }